import { useEffect, useMemo, useState } from "react";
import Switch from "react-switch";
import { SvgAudioLibrary } from "ui/svgs";
import { AdvancedAISettingType } from "lib/types";
import { Tooltip, Select, Checkbox, Skeleton, Modal, Button } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { getIpSpeakers } from "pages/service";
import { SvgToastInfo } from "ui/svgs";
import clsx from "clsx";
import DraggableButton from "ui/automation/language-dragable-button";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { VgInstructionModal } from "./advancedAI-vg-instruction-modal";
const langsText = ["English", "Spanish", "Japanese", "Korean"];
export default function AdvancedAISetting(props: {
  camera;
  advancedAISetting: AdvancedAISettingType;
  setAdvancedAISetting: (data: AdvancedAISettingType) => void;
}) {
  const { camera, advancedAISetting, setAdvancedAISetting } = props;
  const [buttons, setButtons] = useState(() => {
    const languages = advancedAISetting?.virtualGuard?.languages || [];
    const unSelectedButtons =
      langsText.filter((button) => !languages?.includes(button)) || [];
    return [...languages, ...unSelectedButtons];
  });
  const [instructionVisible, setInstructionVisible] = useState(false);
  const [speakerOpionsLoading, setSpeakerOpionsLoading] = useState(true);
  const [speakerOpions, setSpeakerOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [showAiTip, setShowAiTip] = useState(true);
  const [
    showDisableHumanAlertContirmModal,
    setShowDisableHumanAlertContirmModal,
  ] = useState(false);

  useEffect(() => {
    const showAiTip = Boolean(
      parseInt(localStorage.getItem("showAiTip") || "1"),
    );
    setShowAiTip(showAiTip);
  }, []);

  const handleSpeakerChange = (value) => {
    setAdvancedAISetting({
      ...advancedAISetting,
      virtualGuard: {
        ...advancedAISetting?.virtualGuard,
        speakerIds: value,
      },
    });
  };
  const siteId = useMemo(() => {
    return +camera?.siteId;
  }, [camera]);

  useEffect(() => {
    if (siteId === null && siteId === undefined) {
      return;
    }
    const prepareSpeakers = async () => {
      try {
        setSpeakerOpionsLoading(true);
        const data = await getIpSpeakers(camera?.orgId, siteId);
        setSpeakerOpionsLoading(false);
        const speakers = data?.data;
        setSpeakerOptions(
          speakers?.map((e) => ({
            value: e?.id,
            label: e?.name,
          })),
        );
      } catch (error) {
        console.error("Error in getting speakers", error);
      }
    };
    prepareSpeakers();
  }, [siteId]);

  const onDragMove = (fromIndex, toIndex) => {
    const newButtons = [...buttons];
    const [movedButton] = newButtons.splice(fromIndex, 1);
    newButtons.splice(toIndex, 0, movedButton);
    console.log("after dragMove", newButtons);
    const languages = advancedAISetting?.virtualGuard?.languages || [];
    // sort by buttons
    languages?.sort((a, b) => {
      const aIndex = newButtons.findIndex((button) => button === a);
      const bIndex = newButtons.findIndex((button) => button === b);
      return aIndex - bIndex;
    });
    console.log("languages", languages);
    setAdvancedAISetting({
      ...advancedAISetting,
      virtualGuard: {
        ...advancedAISetting?.virtualGuard,
        languages,
      },
    });
    setButtons(newButtons);
  };

  const handleSwitchLPR = () => {
    if (advancedAISetting?.enableVehicle) {
      Modal.confirm({
        title: 'Do you want to disable "Process Human Alerts"?',
        icon: null,
        width: 550,
        content:
          'Disabling "Process Vehicle Alerts" will permanently make "Plate Detection"unavailable until re-enabled.',
        async onOk() {
          setAdvancedAISetting({
            ...advancedAISetting,
            enableVehicle: !advancedAISetting?.enableVehicle,
          });
        },
        okText: "Disable Anyway",
        okButtonProps: {
          className: "primaryButton ",
        },
        cancelButtonProps: {
          className: "primaryButton bordered",
        },
      });
    } else {
      setAdvancedAISetting({
        ...advancedAISetting,
        enableVehicle: !advancedAISetting?.enableVehicle,
      });
    }
  };

  if (speakerOpionsLoading) {
    return (
      <div className="w-full h-full px-6 py-6">
        <Skeleton />
      </div>
    );
  }

  return (
    <div className="w-full h-full">
      <div className="py-2 flex gap-6 justify-center text-base">
        <div className="bg-[#fafafa] p-6 rounded-2xl basis-[33%] ">
          <p className="font-semibold text-xl mb-3">Processor</p>
          <div className="flex items-center justify-between py-3 rounded-2xl bg-[#fafafa]">
            <span className="font-semibold">Process Human Alerts</span>
            <Switch
              onChange={() => {
                if (!advancedAISetting?.enablePerson) {
                  setAdvancedAISetting({
                    ...advancedAISetting,
                    enablePerson: !advancedAISetting?.enablePerson,
                  });
                } else {
                  setShowDisableHumanAlertContirmModal(true);
                }
              }}
              checked={advancedAISetting?.enablePerson}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor="#3E83F6"
              offColor="#fff"
              handleDiameter={20}
              offHandleColor="#9E9E9E"
              className="border border-zinc-200"
              height={32}
              width={52}
            />
          </div>
          <div className="flex items-center justify-between py-3 rounded-2xl bg-[#fafafa]">
            <span className="font-semibold">Process Vehicle Alerts</span>
            <Switch
              onChange={handleSwitchLPR}
              checked={advancedAISetting?.enableVehicle}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor="#3E83F6"
              offColor="#fff"
              handleDiameter={20}
              offHandleColor="#9E9E9E"
              className="border border-zinc-200"
              height={32}
              width={52}
            />
          </div>
          <div className="flex items-center justify-between py-3  rounded-2xl bg-[#fafafa]">
            <span className="font-semibold">Process Non Vehicle Alerts</span>
            <Switch
              onChange={() => {
                setAdvancedAISetting({
                  ...advancedAISetting,
                  enableNonMotor: !advancedAISetting?.enableNonMotor,
                });
              }}
              checked={advancedAISetting?.enableNonMotor}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor="#3E83F6"
              offColor="#fff"
              handleDiameter={20}
              offHandleColor="#9E9E9E"
              className="border border-zinc-200"
              height={32}
              width={52}
            />
          </div>
          <div className="flex items-center justify-between py-3 rounded-2xl bg-[#fafafa]">
            <span className="font-semibold">Process Investigated Alert</span>
            <Switch
              onChange={() => {
                setAdvancedAISetting({
                  ...advancedAISetting,
                  enableCase: !advancedAISetting?.enableCase,
                });
              }}
              checked={advancedAISetting?.enableCase}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor="#3E83F6"
              offColor="#fff"
              handleDiameter={20}
              offHandleColor="#9E9E9E"
              className="border border-zinc-200"
              height={32}
              width={52}
            />
          </div>
          {/* <div className="mt-8 flex justify-between items-center">
        <span>Pitch</span>
        <Select
          style={{ width: "calc(100% - 100px)" }}
          defaultValue={"Medium"}
          value={advancedAISetting?.virtualGuard?.pitch}
          popupClassName="advancedAI-select-dropdown"
          className="h-10 rounded-2xl"
          options={[
            { label: "Medium", value: "Medium" },
            { label: "High", value: "High" },
            { label: "X-High", value: "X-High" },
          ]}
          onChange={(value) => {
            setAdvancedAISetting({
              ...advancedAISetting,
              virtualGuard: {
                ...advancedAISetting?.virtualGuard,
                pitch: value,
              },
            });
          }}
        />
      </div>
      <div className="mt-8 flex justify-between items-center">
        <span>Volume</span>
        <Select
          style={{ width: "calc(100% - 100px)" }}
          defaultValue={"Medium"}
          value={advancedAISetting?.virtualGuard?.volume}
          popupClassName="advancedAI-select-dropdown"
          className="h-10 rounded-2xl"
          options={[
            { label: "Medium", value: "Medium" },
            { label: "Loud", value: "Loud" },
            { label: "X-Loud", value: "X-Loud" },
          ]}
          onChange={(value) => {
            setAdvancedAISetting({
              ...advancedAISetting,
              virtualGuard: {
                ...advancedAISetting?.virtualGuard,
                volume: value,
              },
            });
          }}
        />
      </div>
      <div className="mt-8 flex justify-between items-center">
        <span>Rate</span>
        <Select
          style={{ width: "calc(100% - 100px)" }}
          defaultValue={"Medium"}
          value={advancedAISetting?.virtualGuard?.rate}
          popupClassName="advancedAI-select-dropdown"
          className="h-10 rounded-2xl"
          options={[
            { label: "Medium", value: "Medium" },
            { label: "Loud", value: "Loud" },
            { label: "X-Loud", value: "X-Loud" },
          ]}
          onChange={(value) => {
            setAdvancedAISetting({
              ...advancedAISetting,
              virtualGuard: {
                ...advancedAISetting?.virtualGuard,
                rate: value,
              },
            });
          }}
        />
      </div> */}
        </div>
        <div className="bg-[#fafafa] p-6 rounded-2xl basis-[33%] ">
          <p className="font-semibold text-xl mb-3">Virtual Guard </p>
          {!camera?.capabilities?.speak && speakerOpions?.length === 0 && (
            <p className="text-[#717171] mt-6 break-normal">
              Add an IP speaker or use a camera with speaker support to enable
              this feature
            </p>
          )}
          {camera?.capabilities?.speak && (
            <div className="flex items-center justify-between py-3 rounded-2xl bg-[#fafafa]">
              <span className="font-semibold text-base">
                Virtual Guard with Camera Speaker
              </span>
              <Switch
                onChange={() => {
                  setAdvancedAISetting({
                    ...advancedAISetting,
                    virtualGuard: {
                      ...advancedAISetting?.virtualGuard,
                      cameraSpeakerEnabled:
                        !advancedAISetting?.virtualGuard?.cameraSpeakerEnabled,
                    },
                  });
                }}
                checked={advancedAISetting?.virtualGuard?.cameraSpeakerEnabled}
                uncheckedIcon={false}
                checkedIcon={false}
                onColor="#3E83F6"
                offColor="#fff"
                handleDiameter={20}
                offHandleColor="#9E9E9E"
                className="border border-zinc-200"
                height={32}
                width={52}
              />
            </div>
          )}

          {(speakerOpions?.length > 0 ||
            advancedAISetting?.virtualGuard?.speakerIds?.length > 0) && (
            <div className="py-3 rounded-2xl bg-[#fafafa]">
              <div className="flex items-center justify-between gap-1">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-base">
                    Virtual Guard with IP Speaker
                  </span>
                  <Tooltip title="Requires an IP Speaker. Connect one to enable this feature.">
                    <div className="hover:bg-gray-100 hover-bg-gray-100 w-4 h-4 cursor-pointer">
                      <SvgToastInfo width="16" className="fill-neutral-500" />
                    </div>
                  </Tooltip>
                </div>

                <Switch
                  onChange={() => {
                    const setting = {
                      ...advancedAISetting,
                      virtualGuard: {
                        ...advancedAISetting?.virtualGuard,
                        ipSpeakerEnabled:
                          !advancedAISetting?.virtualGuard?.ipSpeakerEnabled,
                      },
                    };
                    advancedAISetting?.virtualGuard?.ipSpeakerEnabled &&
                      (setting.virtualGuard.speakerIds = []);
                    setAdvancedAISetting(setting);
                  }}
                  checked={advancedAISetting?.virtualGuard?.ipSpeakerEnabled}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  onColor="#3E83F6"
                  offColor="#fff"
                  handleDiameter={20}
                  offHandleColor="#9E9E9E"
                  className="border border-zinc-200"
                  height={32}
                  width={52}
                />
              </div>
              {advancedAISetting?.virtualGuard?.ipSpeakerEnabled && (
                <>
                  <div className="mt-3 rounded-2xl bg-[#fafafa]">
                    <Select
                      mode="multiple"
                      popupClassName="advancedAI-select-dropdown"
                      loading={true}
                      style={{ width: "100%" }}
                      options={speakerOpions}
                      className="speakerSelect"
                      value={advancedAISetting?.virtualGuard?.speakerIds}
                      onChange={handleSpeakerChange}
                      placeholder="All speakers are enabled by default."
                      suffixIcon={null}
                      labelRender={(label) => (
                        <div className="flex gap-2 pr-2">
                          <SvgAudioLibrary
                            width={18}
                            className="fill-[#717171]"
                          />
                          {label.label}
                        </div>
                      )}
                    />
                  </div>
                </>
              )}
            </div>
          )}
          {((speakerOpions?.length > 0 ||
            advancedAISetting?.virtualGuard?.speakerIds?.length > 0) &&
            advancedAISetting?.virtualGuard?.ipSpeakerEnabled) ||
          (camera?.capabilities?.speak &&
            advancedAISetting?.virtualGuard?.cameraSpeakerEnabled) ? (
            <>
              <div className="flex items-center justify-between gap-1">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-base">
                    Instruction Status
                  </span>
                </div>

                <Button type="text" onClick={() => setInstructionVisible(true)}>
                  {advancedAISetting?.virtualGuard?.customPrompt
                    ? "Customized"
                    : "Default"}{" "}
                  <RightOutlined />
                </Button>
              </div>
              <p className="font-semibold mt-3">Languages to Broadcast</p>
              <p className="mt-1 text-[#222222] text-sm">
                Drag to reorder. Each selected language will play twice
                insequence before the next.
              </p>
              <DndProvider backend={HTML5Backend}>
                <div className="flex items-center gap-2 flex-wrap mt-1">
                  {buttons.map((button, index) => {
                    const isSelected =
                      advancedAISetting?.virtualGuard?.languages?.includes(
                        button,
                      );
                    const disabled =
                      advancedAISetting?.virtualGuard?.languages?.length ===
                        3 &&
                      !advancedAISetting?.virtualGuard?.languages?.includes(
                        button,
                      );
                    return (
                      <DraggableButton
                        key={button}
                        id={button}
                        text={button}
                        index={index}
                        canDrag={isSelected}
                        onDragMove={onDragMove}
                        disabled={disabled}
                        onCheck={() => {
                          if (isSelected) {
                            setAdvancedAISetting({
                              ...advancedAISetting,
                              virtualGuard: {
                                ...advancedAISetting?.virtualGuard,
                                languages:
                                  advancedAISetting?.virtualGuard?.languages?.filter(
                                    (l) => l !== button,
                                  ),
                              },
                            });
                          } else {
                            const languages = [
                              ...(advancedAISetting?.virtualGuard?.languages ||
                                []),
                              button,
                            ];
                            // sort by buttons
                            languages?.sort((a, b) => {
                              const aIndex = buttons.findIndex(
                                (button) => button === a,
                              );
                              const bIndex = buttons.findIndex(
                                (button) => button === b,
                              );
                              return aIndex - bIndex;
                            });

                            setAdvancedAISetting({
                              ...advancedAISetting,
                              virtualGuard: {
                                ...advancedAISetting?.virtualGuard,
                                languages,
                              },
                            });
                          }
                        }}
                      />
                    );
                  })}
                </div>
              </DndProvider>
            </>
          ) : null}
        </div>

        <div className="bg-[#fafafa] p-6 rounded-2xl basis-[33%] ">
          <p className="font-semibold text-xl mb-3">Advance Algorithm</p>
          <div className="rounded-2xl bg-[#fafafa]">
            {advancedAISetting?.aiAlgoSettings?.algos?.map((algo) => {
              const disabled =
                (algo.name === "gun_detection" &&
                  !advancedAISetting?.enablePerson) ||
                (algo.name === "lpn_detection" &&
                  !advancedAISetting?.enableVehicle);
              const title = disabled
                ? algo.name === "gun_detection"
                  ? "Enable Process Human Alerts First"
                  : "Enable Process Vehicle Alerts First"
                : "";
              return (
                <Tooltip title={title} key={algo.name}>
                  <div className="flex  items-center justify-between py-3 gap-2">
                    <span
                      className={clsx(
                        "font-semibold",
                        disabled ? "text-gray-400" : "text-black",
                      )}
                    >
                      {algo.display}
                    </span>

                    <Switch
                      disabled={disabled}
                      onChange={() => {
                        setAdvancedAISetting({
                          ...advancedAISetting,
                          aiAlgoSettings: {
                            ...advancedAISetting?.aiAlgoSettings,
                            algos:
                              advancedAISetting?.aiAlgoSettings?.algos?.map(
                                (a) => {
                                  if (a.name === algo.name) {
                                    return {
                                      ...a,
                                      enabled: !a.enabled,
                                    };
                                  }
                                  return a;
                                },
                              ),
                          },
                        });
                      }}
                      checked={algo.enabled}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      onColor="#3E83F6"
                      offColor="#fff"
                      handleDiameter={20}
                      offHandleColor="#9E9E9E"
                      className="border border-zinc-200"
                      height={32}
                      width={52}
                    />
                  </div>
                </Tooltip>
              );
            })}
          </div>
        </div>
      </div>
      {showAiTip && (
        <div className="bg-[#fafafa] p-6 rounded-2xl mt-6 ">
          <div className="flex gap-1 font-semibold mb-4">
            <SvgToastInfo width="16" className="fill-neutral-500" /> Note
          </div>
          <p className="mb-4">
            Enabling these{" "}
            <span className="font-semibold">Advanced AI features</span>
            (including "Virtual Guard with IP/Camera Speaker") will activate the
            platform's advanced AI analytics capabilities. Once activated, the
            system will automatically analyze video data detected by your setup
            to support keyword-based searches in the Magic Search feature.
          </p>
          <p className="mb-4">
            Each use of these AI analytics features will deduct credits from
            your account's purchased (or pre-existing) AI credit balance. When
            the credits are depleted, you will need to purchase additional AI
            credits through the platform's{" "}
            <span className="font-semibold">
              "License - Purchasing AI Credit"{" "}
            </span>
            section to continue using these features.
          </p>
          <p className="mb-4">The cost of each processing is 1 Credit.</p>
          <Checkbox
            className="mr-2"
            onChange={(e) => {
              if (e.target.checked) {
                localStorage.setItem("showAiTip", "0");
              }
            }}
          />
          Don’t show this again
        </div>
      )}
      <Modal
        title={
          <p className="text-xl font-semibold">
            Do you want to disable "Process Human Alerts"?
          </p>
        }
        width={550}
        open={showDisableHumanAlertContirmModal}
        onOk={() => {
          setAdvancedAISetting({
            ...advancedAISetting,
            enablePerson: !advancedAISetting?.enablePerson,
          });
          setShowDisableHumanAlertContirmModal(false);
        }}
        closable={false}
        onCancel={() => setShowDisableHumanAlertContirmModal(false)}
        okText="Disable Anyway"
        cancelText="Cancel"
        okButtonProps={{
          className: "primaryButton",
        }}
        cancelButtonProps={{
          className: "primaryButton bordered",
        }}
      >
        <p className="mt-4 mb-4 break-normal">
          Disabling "Process Human Alerts" will permanently make "Gun Detection"
          unavailable until re-enabled.
        </p>
      </Modal>
      <VgInstructionModal
        visible={instructionVisible}
        onClose={() => setInstructionVisible(false)}
        data={advancedAISetting?.virtualGuard}
        onSave={(instruction, promptCfg) => {
          setAdvancedAISetting({
            ...advancedAISetting,
            virtualGuard: {
              ...advancedAISetting?.virtualGuard,
              customPrompt: instruction,
              customPromptCfg: promptCfg,
            },
          });
        }}
      />
    </div>
  );
}
